import React from "react";
import {Facebook} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {facebookButton} from "../../theme/theme";

declare global {
    interface Window {
        FB: any; // Declare FB to avoid TypeScript errors
    }
}

interface FacebookLoginButtonProps {
    onLoginSuccess: (user: any) => void;
    onLoginFailure?: () => void;
}

const FacebookLoginButton: React.FC<FacebookLoginButtonProps> = ({
    onLoginSuccess,
    onLoginFailure,
}) => {
    const handleLogin = () => {
        window.FB.login(
            (response: any) => {
                if (response.authResponse) {
                    console.log("Fetching user info...");
                    window.FB.api(
                        "/me",
                        {fields: "name,email,picture"},
                        (user: any) => {
                            console.log("User:", user);
                            onLoginSuccess(user);
                        },
                    );
                }
                else {
                    console.error("Login failed");
                    if (onLoginFailure) onLoginFailure();
                }
            },
            {scope: "public_profile,email"},
        );
    };
    return (
        <button
            onClick={handleLogin}
            style={{
                backgroundColor: facebookButton,
                color: "white",
                padding: "12px 24px",
                border: "none",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                cursor: "pointer",
                width: "100%",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                transition: "background-color 0.3s, transform 0.3s",
            }}
        >
            <Facebook sx={{marginRight: "10px"}}/>
            <Locale localeId={IdlocaGeneric.login_with_facebook}/>
        </button>
    );
};
export default FacebookLoginButton;
